import { HamburgerIcon } from "@chakra-ui/icons";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuList,
  MenuItem,
  Select,
  Spinner,
  Button,
  Box,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import { VARIANT, WHITE } from "../../../../constants/colors";
import Pagination from "../../../../defaultComponents/pagination";
import {
  CaptionFormater,
  ToLocaleFormat,
} from "../../../../defaultFunctions/formaters";
import moment from "moment";
import { dateForList } from "../../../../constants/dataFormat";
import { FaEye, FaListAlt, FaTrashAlt } from "react-icons/fa";
import ModalCancelamentoAssinatura from "./modalCancelamentoAssinatura";
import { useNavigate } from "react-router";
import VendasRecorrentesApi from "../../../../services/vendasRecorrentesApi";
import ViewModalAssinaturas from "./viewModalAssinaturas";
import { customColors } from "../../../../atoms/customColors";
import { LISTAGEMPLANOS } from "../../../../constants/paths";
import { FaArrowLeft } from "react-icons/fa";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
interface IListVendasRecorrentes {
  id: number;
  idCliente: number;
  idAssinatura: string;
  idSeller: string;
  idBuyer: string;
  idPlano: string;
  dataProximaCobranca: string;
  dataUltimaTransacao: string;
  statusUltimaTransacao: string;
  dataExpiracao: string;
  valor: number;
  ativo: boolean;
  idCartao: string;
  plano: {
    id: number;
    nome: string;
    descricao: string;
    frequencia: string;
    duracao: number;
    intervalo: number;
    tolerancia: null;
    valor: number;
    taxa: number;
    idCliente: number;
    idPlano: string;
  };
  cliente: {
    id: number;
    nome: string;
    sobrenome: string;
    saldo: number;
    ativo: boolean;
    cnpj: string;
    isCnpj: boolean;
    razaoSocial: string;
    nomeFantasia: string;
    email: string;
    idPlano: number;
    idTarifa: number;
    idPromocao: number;
    idProjeto: number;
    idRede: number;
    dataNascProprietario: string;
    apiout: boolean;
  };
}

function ListadeAssinaturasVinculadas() {
  const [assinaturas, setAssinaturas] = useState(Array<IListVendasRecorrentes>);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [pages, setPages] = useState(1);
  const [openView, setOpenView] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  const [itemToDetail, setItemToDetail] = useState(
    {} as IListVendasRecorrentes
  );

  const colors = useRecoilState(customColors)[0];

  const refresh = useRecoilState(refreshGlobal)[0];

  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const idCliente = searchParams.get("idCliente") || "";
  const idPlano = searchParams.get("idPlano") || "";

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
    }
  }, [pages]);

  async function getListaVendasRecorrentes() {
    try {
      setLoading(true);
      const response = await VendasRecorrentesApi.getListaVendasRecorrentes(
        currentPage,
        pageSize,
        Number(idCliente), // Certifique-se de converter para número
        idPlano
      );
      setPages(
        Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
      );
      setAssinaturas(response.data);
    } catch (error) {
      toast.error("Erro ao carregar assinaturas vinculadas");
      console.error(error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (idCliente) {
      getListaVendasRecorrentes();
    }
  }, [refresh, currentPage, pageSize, idCliente, idPlano]);
  return (
    <>
      <Box bg="white" w="100%" p={4} mb={4} boxShadow="lg">
        <Flex justify="flex-end">
          <Button
            leftIcon={<FaArrowLeft />}
            style={{ color: "white" }}
            onClick={() => {
              navigate(LISTAGEMPLANOS);
            }}
            _hover={{ bg: "#4B4B57" }}
            bgColor={colors.GRAY}
          >
            Voltar a Lista de Planos
          </Button>
        </Flex>
      </Box>

      <Flex justify="center" mb={4}>
        <Text fontWeight={"bold"} fontSize={"20px"}>
          Lista de Assinaturas
        </Text>
      </Flex>
      {!loading ? (
        <Flex flexDir={"column"}>
          <TableContainer
            overflowY={"auto"}
            overflowX={"auto"}
            h={"64vh"}
            w={"84vw"}
          >
            <Table variant="striped">
              <Thead h="60px" zIndex={1} position="sticky" top="0">
                <Tr>
                  <Th
                    borderRadius={"8px 0 0 8px"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Cliente
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Plano
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data Primeira Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Data ùltima Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Status Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={WHITE}>
                    Ativo
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Taxa Primeira Cobrança
                  </Th>
                  <Th bgColor={colors.BLUEMONEDDBUTTONS} color={colors.WHITE}>
                    Valor
                  </Th>
                  <Th
                    borderRadius={"0 8px 8px 0"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {assinaturas && assinaturas.length > 0 ? (
                  assinaturas.map((item, index) => (
                    <Tr key={index}>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {item?.cliente?.isCnpj
                          ? CaptionFormater(item?.cliente?.razaoSocial)
                          : `${CaptionFormater(
                              item?.cliente?.nome
                            )} ${CaptionFormater(item?.cliente?.sobrenome)}`}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {CaptionFormater(item?.plano?.nome)}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {item?.dataProximaCobranca
                          ? moment(item.dataProximaCobranca).format(dateForList)
                          : ""}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {item?.dataUltimaTransacao
                          ? moment(item.dataUltimaTransacao).format(dateForList)
                          : ""}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {item?.statusUltimaTransacao || ""}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {item?.ativo ? "Sim" : "Não"}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {item?.plano?.taxa
                          ? ToLocaleFormat(item.plano.taxa / 100)
                          : "R$ 0,00"}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        {item?.plano?.valor
                          ? ToLocaleFormat(item.plano.valor / 100)
                          : "R$ 0,00"}
                      </Td>
                      <Td
                        color={item.ativo ? "inherit" : "red"}
                        fontWeight={item.ativo ? "normal" : "bold"}
                      >
                        <Menu>
                          <MenuButton
                            as={IconButton}
                            aria-label="Options"
                            icon={<HamburgerIcon />}
                            bgColor={colors.BLUEMONEDDBUTTONS}
                            color={colors.WHITE}
                            size={"sm"}
                          />
                          <MenuList>
                            <MenuItem
                              onClick={() => {
                                setOpenView(true);
                                setItemToDetail(item);
                              }}
                              icon={<FaEye />}
                            >
                              Visualizar Assinatura
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                setOpenDelete(true);
                                setItemToDetail(item);
                              }}
                              icon={<FaTrashAlt />}
                            >
                              Cancelar Assinatura
                            </MenuItem>
                            <MenuItem
                              onClick={() => {
                                navigate(
                                  `/vendasrecorrentes/listagem/transacoes/${item.idBuyer}`
                                );
                              }}
                              icon={<FaListAlt />}
                            >
                              Ver Transações
                            </MenuItem>
                          </MenuList>
                        </Menu>
                      </Td>
                    </Tr>
                  ))
                ) : (
                  <Tr>
                    <Td colSpan={9} textAlign="center">
                      Nenhuma assinatura encontrada.
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
            </Select>
          </Flex>
        </Flex>
      ) : (
        <Flex
          w={"100%"}
          h={"85%"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Spinner color={colors.VARIANT} size={"lg"} />
        </Flex>
      )}

      <ViewModalAssinaturas
        isOpen={openView}
        setIsOpen={setOpenView}
        item={itemToDetail}
      />
      <ModalCancelamentoAssinatura
        isOpen={openDelete}
        setIsOpen={setOpenDelete}
        id={itemToDetail.idAssinatura}
      />
    </>
  );
}
export default ListadeAssinaturasVinculadas;
